<template>
  <div class="orient_earlier">
    <div class="same_title">更早动态</div>
    <div class="orient_earlier_content">
      <p class="no_content" v-if="earlierList.length === 0">暂无内容</p>
      <div v-if="earlierList.length > 0"><z-list :list="lList" @toDetail="toDetail"></z-list></div>
      <div v-if="earlierList.length > 0"><z-list :list="rList" @toDetail="toDetail"></z-list></div>
    </div>
  </div>
</template>

<script>
import list from '@/components/list/list'
export default {
  name: 'orientEarlier',
  components: {
    'z-list': list
  },
  props: ['earlierList'],
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  computed: {
    lList () {
      let list = []
      this.earlierList.forEach((item, index) => {
        if (index % 2 === 0) {
          list.push(item)
        }
      })
      return list
    },
    rList () {
      let list = []
      this.earlierList.forEach((item, index) => {
        if (index % 2 > 0) {
          list.push(item)
        }
      })
      return list
    }
  },
  methods: {
    toDetail (itemId) {
      this.$router.push({
        path: '/dynamic/detail',
        query: {
          itemId: itemId
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .orient_earlier { height: 333px; padding: 0 15px; border-radius: 2px; border: 1px solid #DCDFE6; }
  .orient_earlier .orient_earlier_content { height: 275px; overflow: auto; padding-bottom: 20px; display: flex; justify-content: space-between; }
  .orient_earlier .orient_earlier_content > div { width: 460px; }
</style>



// WEBPACK FOOTER //
// src/components/dynamic/earlier.vue